import { SearchOutlined } from '@mui/icons-material'
import { InputAdornment, ListItemButton, TextField } from '@mui/material'
import EventsEngine from '../../../engines/EventsEngine'
import Helper from '../../../helpers/Helper'

function QuickSpotlight() {
    const os = Helper.platform()
    const modifier = os === 'Mac' ? '⌘' : 'Ctrl'

    return (
        <ListItemButton
            sx={{ padding: 0, marginBottom: 1, borderRadius: 2 }}
            onClick={() => EventsEngine.publish('open-spotlight')}>
            <TextField
                fullWidth
                autoComplete='off'
                placeholder='Search'
                variant='outlined'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position='start' sx={{ minWidth: 'calc(var(--unit)*4)' }}>
                            <SearchOutlined />
                        </InputAdornment>
                    ),
                    endAdornment: <span className='kbd'>{modifier}+K</span>,
                    style: { height: 'calc(var(--unit) * 6)' }
                }}
                style={{ pointerEvents: 'none' }}
            />
        </ListItemButton>
    )
}

export default QuickSpotlight
